import { RootState } from '../../rootReducer';

export const bookSelectors = {
  getBooks: (state: RootState) => state.BooksState.books,
  getBook: (state: RootState, id?: string) =>
    (id && state.BooksState?.books?.find((book) => book.id === id)) ||
    undefined,
  getBookList: (state: RootState) => state.BooksState.bookList,
  getBookSearchResult: (state: RootState) => state.BooksState.bookSearchResult,
  getBookStats: (state: RootState) => state.BooksState.booksStats,
  getBooksForUser: (state: RootState) => state.BooksState.listBookForUser,
};
